var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m 2,14 c 1.1,0 2,-0.9 2,-2 V 2 C 4,0.9 3.1,0 2,0 0.9,0 0,0.9 0,2 v 10 c 0,1.1 0.9,2 2,2 z M 8,2 v 10 c 0,1.1 0.9,2 2,2 1.1,0 2,-0.9 2,-2 V 2 C 12,0.9 11.1,0 10,0 8.9,0 8,0.9 8,2 Z","id":"path2"}));
}

Pause.defaultProps = {"width":"100%","viewBox":"0 0 12 14"};

module.exports = Pause;

Pause.default = Pause;
